import { render } from "./CreateCompanyForm.vue?vue&type=template&id=fa5fd562"
import script from "./CreateCompanyForm.vue?vue&type=script&lang=js"
export * from "./CreateCompanyForm.vue?vue&type=script&lang=js"

import "./CreateCompanyForm.vue?vue&type=style&index=0&id=fa5fd562&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__